/** Snapshot of Clerk session state used by `useClerkAuthRecoverySessionRegistration`. */
export type ClerkAuthRecoverySessionState = {
  isSessionLoaded: boolean;
  isSignedIn: boolean | undefined;
  sessionStatus: string | undefined;
  organizationId: string | null;
};

/** SC-2589: recovery only when Clerk reports an active signed-in session with an org selected. */
export function isClerkAuthRecoverySessionEligible(state: ClerkAuthRecoverySessionState): boolean {
  return state.isSessionLoaded && state.isSignedIn === true && state.sessionStatus === "active" && state.organizationId !== null;
}
